import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import GroupedSelect from "./GroupedSelect";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import MonthYearPicker from "./MonthYearPicker";
import Button from "./Button";
import ActionButton from "./ActionButton";
import AutoComplete from "./AutoComplete";
import UploadButton from "./Upload";

const Controls = {
  Input,
  RadioGroup,
  Select,
  GroupedSelect,
  Checkbox,
  DatePicker,
  Button,
  ActionButton,
  AutoComplete,
  UploadButton,
  MonthYearPicker,
};

export default Controls;
